<footer class="footer" data-background-color="black">
  <div class="container">
    <div class="copyright" id="copyright">
      &copy; {{ year }} Daystar Christian Centre. All rights reserved.
    </div>
  </div>
</footer>
